/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ userId: ZodTypes.Id });

export const AdminUserStatusPatch = {
  id: 'admin-user-status.patch',
  tag: 'Admin',
  summary: 'Update user status',
  description: 'Update user status',
  method: 'patch',
  flags: { isAuthorized: true, isSuperuser: true },
  route: (params: z.infer<typeof Params>) => `/administration/user/${params.userId}/status`,
  request: {
    query: z.strictObject({
      isDisabled: z
        .string()
        .refine(value => value === 'true' || value === 'false', {
          message: 'Value must be a boolean',
        })
        .transform(value => value === 'true'),
    }),
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
